module.exports = __webpack_public_path__ + "img/objImage.2152f463.svg";